import React, { useState } from 'react'
import { Link } from 'react-feather'
import colors from '../theme/colors'
import Title from '../components/titles'
import styled from 'styled-components'
import HTMLBlock from '../components/html-content'
import { GatsbyImage } from 'gatsby-plugin-image'
import get from 'lodash.get'
import { useLocation } from '@reach/router'

export const CardActu = (post) => {
    const { uid } = get(post, 'post')
    const { title, cover, content } = get(post, 'post.data')
    const location = useLocation()
    const postUrl = location.href + '/' + uid

    const [tooltipVisible, setTooltipVisible] = useState(false)

    const copyUrl = () => {
        setTooltipVisible(true)
        navigator.clipboard.writeText(postUrl)
        setTimeout(() => {
            setTooltipVisible(false)
        }, 2000)
    }

    return (
        <StyledCardContainer>
            <StyledImage
                image={get(cover, 'localFile.childImageSharp.gatsbyImageData')}
                alt={cover.alt || 'illustration'}
            />

            <StyledContent>
                <StyledHeader>
                    <Title size='medium' as='h3' withDot>
                        {title.text}
                    </Title>
                    <StyledIconContainer onClick={copyUrl}>
                        <StyledTooltip style={{
                            visibility: tooltipVisible ? 'visible' : 'hidden',
                            opacity: tooltipVisible ? 1 : 0
                        }}>
                            Lien copié
                        </StyledTooltip>
                        <Link size={16} color={colors.white80} />
                    </StyledIconContainer>
                </StyledHeader>

                <HTMLBlock>{content.html}</HTMLBlock>
            </StyledContent>
        </StyledCardContainer>
    )
}

const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background-color: white;
  margin-bottom: 8px;
`

const StyledImage = styled(GatsbyImage)`
  flex-shrink: 0;
  margin: 0;
  width: 100%;
`

const StyledContent = styled.div`
  padding: 0 1rem;
  margin: 1rem 0;
  overflow-y: auto;
`

const StyledHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`

const StyledIconContainer = styled.div`
  position: relative;
  height: fit-content;
  padding: 8px;
  background-color: #21294d;
  border-radius: 50%;
`

const StyledTooltip = styled.small`
  position: absolute;
  bottom: -26px;
  right: -8px;
  background-color: #21294d;
  color: white;
  padding: 4px 8px;
  font-size: 12px;
  text-wrap: nowrap;
  border-radius: 4px;
  transition: opacity 0.5s ease, visibility 0.5s ease;
`

